import { Theme, createTheme, tableCellClasses } from "@mui/material";

export const useComponentsTheme = (theme: Theme): Theme => {
    theme = createTheme(theme, {
        components: {
            MuiButton: {
                defaultProps: {
                    variant: "contained",
                    color: "primary",
                    disableElevation: true,
                },
                styleOverrides: {
                    root: {
                        fontWeight: 400,
                    },
                },
                variants: [
                    {
                        props: { variant: "text", color: "secondary" },
                        style: {
                            color: theme.palette.secondary.contrastText,
                        },
                    }
                ]
            },
            MuiDialog: {
                styleOverrides: {
                    root: {
                        zIndex: theme.zIndex.drawer * 4,
                    }
                }
            },
            MuiIconButton: {
                variants: [
                    {
                        props: { color: "secondary" },
                        style: {
                            [`&.MuiIconButton-root`]: {
                                color: theme.palette.grey[600],
                            }
                        }
                    }
                ]
            },
            MuiLoadingButton: {
                defaultProps: {
                    variant: "contained",
                    color: "primary",
                    disableElevation: true,
                },
            },
            MuiPagination: {
                defaultProps: {
                    shape: "rounded",
                    color: "primary",
                    boundaryCount: 2,
                }
            },
            MuiAutocomplete: {
                styleOverrides: {
                    popper: {
                        zIndex: theme.zIndex.drawer * 4,
                    },
                    paper: {
                        zIndex: theme.zIndex.drawer * 4,
                    },
                },
            },
            MuiSelect: {
                defaultProps: {
                    MenuProps: {
                        style: {
                            zIndex: theme.zIndex.drawer * 4,
                        }
                    }
                }
            },
            MuiTableRow: {
                styleOverrides: {
                    root: {
                        [`& .${tableCellClasses.root}`]: {
                            borderBottom: `1px solid ${theme.palette.divider}`,
                            padding: `${theme.spacing(0.75)} ${theme.spacing(1)}`,

                        },
                        [`& .${tableCellClasses.root} .MuiTypography-root`]: {
                            fontSize: `15px!important`,
                        },
                        [`&.MuiTableRow-hover:hover`]: {
                            backgroundColor: `${theme.palette.grey[50]}!important`,
                        },
                        [`&.MuiTableRow-hover:hover .MuiTableCell-root`]: {
                            backgroundColor: `${theme.palette.grey[50]}!important`,
                        },
                        [`&.MuiTableRow-head .MuiTableCell-head .MuiTypography-root`]: {
                            fontSize: `13px!important`,
                        }
                    }
                }
            },
            MuiTextField: {
                variants: [
                    {
                        props: { variant: "filled" },
                        style: {
                            "& .MuiFilledInput-root": {
                                backgroundColor: theme.palette.grey[100],
                                borderRadius: `${theme.shape.borderRadius}px`,
                                border: `1px solid ${theme.palette.divider}`,
                            },
                            "& .MuiFilledInput-root.Mui-error": {
                                borderColor: theme.palette.error.main,
                            },
                            "& :before, & :after": {
                                display: "none",
                            },
                            "& .MuiInputLabel-root": {
                                color: theme.palette.text.secondary,
                                "&.Mui-focused": {
                                    color: theme.palette.text.secondary,
                                }
                            },
                        },
                    },
                ],
            },
            MuiCheckbox: {
                styleOverrides: {
                    root: {
                        padding: theme.spacing(0.75),
                        color: theme.palette.grey[400],
                    }
                },
            },
            MuiRadio: {
                styleOverrides: {
                    root: {
                        padding: theme.spacing(0.75),
                        color: theme.palette.grey[400],
                    }
                },
            },
            MuiLink: {
                styleOverrides: {
                    root: {
                        cursor: "pointer",
                    }
                }
            },
            MuiTooltip: {
                styleOverrides: {
                    popper: {
                        zIndex: theme.zIndex.drawer * 4,
                    },
                    paper: {
                        zIndex: theme.zIndex.drawer * 4,
                    },
                },
            },
            MuiFab: {
                defaultProps: { size: "large", color: "primary" },
                variants: [
                    {
                        props: { size: "large" },
                        style: {
                            height: 60,
                            width: 60
                        }
                    },
                ]
            },
        },
        typography: {
            button: {
                textTransform: 'none',
            },
        },
    });

    return theme;
}